import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "KDE 4.0",
  "description": "",
  "published": "2007-01-05T00:00:00.000Z",
  "redirect_from": ["/blog/kde-40/swizec/337"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Res je, da je KDE 4.0 oddaljen se kar nekaj mesecev, ampak vanj je bilo vlezenega ze kar nekaj pompa in lepa kolicina spekulacij o tem, kako bo pravzaprav izgledal. `}<a parentName="p" {...{
        "href": "http://linuxhelp.blogspot.com/2007/01/sneek-preview-of-expected-features-in.html"
      }}>{`Tu `}{`[`}{`angleski vir`}{`]`}</a>{` je ena prvih zanesljivih informacij o njem, ki lepo poda nekaj kljucnih izbolsjav do katerih bo prislo.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      